import { createContext, useContext, useState } from 'react';

const ResultContext = createContext();

export const useResult = () => useContext(ResultContext);

export function ResultProvider({ children }) {
  const [selectedResult, setSelectedResult] = useState('');

  return (
    <ResultContext.Provider value={{ selectedResult, setSelectedResult }}>
      {children}
    </ResultContext.Provider>
  );
}
